export default "__VITE_ASSET__CRr14bl8__";